export const GalleryResourceTypes = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  MESSAGES: 'video-message',
};

export const GalleryUploadStatus = {
  QUEUED: 'queued',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  FAILED: 'failed',
};
